import React from "react";
import "./styles.scss";
import CustomRow from "../../shared/costum-row/costum-row";
import { Col, Typography } from "antd";
import { SERVICE_PROCESS_DIRECTION } from "../../constants/props";

const { Title, Text } = Typography;

type ServiceProcessType = {
  number: number;
  title: string;
  description: string;
  direction: SERVICE_PROCESS_DIRECTION;
};

const ServiceProcess = ({
  number,
  title,
  description,
  direction,
}: ServiceProcessType) => {
  // Split the title into words to better control layout
  const words = title.split(" ");

  return (
    <div className={`ServiceProcess ServiceProcess-${direction}`}>
      <div className="ServiceProcess-container">
        <div className="ServiceProcess-item">
          <Title className="ServiceProcess-number">{number}</Title>
          <Title className="ServiceProcess-title">{words.join(" ")}</Title>
          {/* <div className="ServiceProcess-title-wrapper">
          </div> */}
        </div>
      </div>
      <div className="ServiceProcess-container">
        <Text className="ServiceProcess-description">{description}</Text>
      </div>
    </div>
  );
};

export default ServiceProcess;
